import { styled } from "@mui/material/styles"
import { Stack } from "@mui/material"

export const StyledPollOptionStack = styled(Stack)({
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
})
